import styles from "./Spinner.module.scss"
import React from "react";
import {Spinner} from "react-bootstrap";

const LoadingSpinner = () => {

    return <Spinner as="span" animation="border" size="sm" className={styles.spinner}/>;
};

export default LoadingSpinner;